window.addEventListener("load",function(){
    document.documentElement.style.setProperty('--header-height', document.querySelector(".site-header").clientHeight + 'px');
    $(".contact-tab-item").click(function(){
      if(!$(this).hasClass("active")){
        let index = $(this).index()
        $(this).siblings().removeClass("active")
        $(this).addClass("active")
        $(this).parent().parent().find(".contact-tab-contents").find(".contact-tab-content").removeClass("active")
        $(this).parent().parent().find(".contact-tab-contents").find(".contact-tab-content").eq(index).addClass("active")
      }
    })
    $(".js_show_custom").click(function() {
      let id = $(this).data("htmlid")
      $(id).find(".custom_html_content").removeClass("d-none")
    })
    $(".b2g1_section2_product_variant").click(function(){
      
      if (!$(this).hasClass("active")) {
        let image = $(this).data("image")
        let id = $(this).data("id")
        let price = $(this).data("price")
        let comprice = $(this).data("comprice")
         $(this).parent().find(".b2g1_section2_product_variant").removeClass("active")
         $(this).addClass("active")
        $(this).parents(".b2g1_section2_product").find(".b2g1_section2_product_image").find("img").removeAttr("srcset")
        $(this).parents(".b2g1_section2_product").find(".b2g1_section2_product_image").find("img").attr("src",image)
        $(this).parents(".b2g1_section2_product_info").find(".b2g1_section2_product_price").text(price)
        $(this).parents(".b2g1_section2_product_info").find(".b2g1_section2_product_comprice").find("del").text(comprice)
        $(this).parents(".b2g1_section2_content").find(".b2g1_section2_getOffer").data("id2",id)
      }
    })
    $(".b2g1_section2_getOffer").click(function() {
      let id1 = $(this).data("id1")
      let id2 = $(this).data("id2")
      let id3 = $(this).data("id3")
        let items = [
        {
         id: id1,
         quantity: 1
        },
         {
         id: id2,
         quantity: 1
        },
        {
         id: id3,
         quantity: 1
        }
      ]
      $.ajax({
        type: "POST",
        url:"/cart/add.js",
        data:{items},
        dataType:"json",
        success:function(res){
          window.location.href ="/checkout"
        }
      })
    })
    $(".js_open_bigImg").click(function(){
      let img = $(this).data("image")
      $(".bigImage_pop_content").html(`<img src="${img}">`)
      $(".bigImage_pop").fadeIn()
      $("html").addClass("popupBox")
      $("body").addClass("popupBox")
    })
    $(".bigImage_pop").click(function() {
      $(".bigImage_pop_content").html("")
      $(".bigImage_pop").fadeOut()
      $("html").removeClass("popupBox")
      $("body").removeClass("popupBox")
    })
  })